"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountriesFactory = void 0;
const CheckoutRequestHandler_1 = require("../requestHandlers/CheckoutRequestHandler");
class CountriesFactory {
    constructor() {
        this.awaitingCountriesPromise = null;
        this.awaitingStatesPromise = null;
        this.allCountries = null;
        this.allStates = null;
    }
    /**
     * get all countries
     * @param shopId
     */
    getAllCountries(shopId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allCountries) {
                return this.allCountries;
            }
            if (this.awaitingCountriesPromise) {
                yield this.awaitingCountriesPromise;
                return this.allCountries;
            }
            this.awaitingCountriesPromise = CheckoutRequestHandler_1.CheckoutRequestHandler.countriesLookup(shopId);
            this.allCountries = yield this.awaitingCountriesPromise;
            this.awaitingCountriesPromise = null;
            return this.allCountries;
        });
    }
    /**
     * get certain country
     * @param countryCode
     */
    getCountryByCode(countryCode) {
        if (!this.allCountries) {
            return undefined;
        }
        return this.allCountries.find((country) => country.countryCode === countryCode);
    }
    /**
     * get all states of a country
     * @param shopId
     * @param countryCode
     */
    getStates(shopId, countryCode) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.allStates && this.allStates[countryCode]) {
                return this.allStates[countryCode];
            }
            if (this.awaitingStatesPromise) {
                try {
                    yield this.awaitingStatesPromise;
                }
                catch (err) {
                    if (((_b = (_a = err.originalError) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status) !== 400) {
                        throw err;
                    }
                }
                return this.awaitingStatesPromise;
            }
            let newStateLookup;
            try {
                this.awaitingStatesPromise = CheckoutRequestHandler_1.CheckoutRequestHandler.stateLookup(shopId, countryCode);
                newStateLookup = { [countryCode]: yield this.awaitingStatesPromise };
            }
            catch (err) {
                if (((_d = (_c = err.originalError) === null || _c === void 0 ? void 0 : _c.response) === null || _d === void 0 ? void 0 : _d.status) !== 400) {
                    throw err;
                }
                newStateLookup = { [countryCode]: [] };
            }
            this.allStates = Object.assign(Object.assign({}, this.allStates), newStateLookup);
            this.awaitingStatesPromise = null;
            return this.allStates[countryCode];
        });
    }
    /**
     * get certain state of a country
     * @param countryCode
     * @param stateCode
     */
    getStateByCode(countryCode, stateCode) {
        if (!this.allStates || !this.allStates[countryCode]) {
            return undefined;
        }
        return this.allStates[countryCode].find((state) => state.stateCode === stateCode);
    }
}
const countriesFactory = new CountriesFactory();
exports.CountriesFactory = countriesFactory;
